/**
 *
 * Asynchronously loads the component for RepresentativeProfile
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
